
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/thailand-elite",
      function () {
        return require("private-next-pages/concierge/thailand-elite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/thailand-elite"])
      });
    }
  